import React from 'react';
import { connect } from 'react-redux';
import { getWatchlistUserSetting } from '../../../main-layout/sidebar/reducer';
import OrganizeColumn from '../common/organize-column';
import { omitBy } from 'lodash';
import { changeListHideColumnIndex, REDUCER_NAME } from './reducer';
import { hideColumns, ignoreColumns, listColumn } from './Const';

class OrganizeColumnIndex extends React.PureComponent {
  constructor(props) {
    super(props);
    const { wlSetting, changeListHideColumn } = props;
    if (wlSetting && wlSetting.cwHideColumns) {
      changeListHideColumn(wlSetting.cwHideColumns);
    }
  }

  render() {
    const { changeListHideColumn, listHideColumnIndex } = this.props;
    return (
      <OrganizeColumn
        listColumn={Object.keys(
          omitBy(listColumn, val => ignoreColumns.includes(val)),
        ).map(item => {
          return {
            key: listColumn[item],
            title: `coveredWarrant.${listColumn[item]}`,
          };
        })}
        listUnCheckedColumn={listHideColumnIndex}
        listUnCheckedColumnDefault={hideColumns}
        changeListHideColumn={changeListHideColumn}
      />
    );
  }
}

const mapStateToProps = state => ({
  listHideColumnIndex: state[REDUCER_NAME].listHideColumnIndex,
  wlSetting: getWatchlistUserSetting(state),
});

const mapDispatchToProps = {
  changeListHideColumn: changeListHideColumnIndex,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizeColumnIndex);
